import { Breadcrumbs, Typography} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import { optionsBreadcrumb } from './options';
import { useContext } from 'react';
import BreadcrumbContext from '../context/BreadcrumbContext';
import { useTranslation } from 'react-i18next';

function BreadcrumbPages() {
  const location = useLocation();
  const { t } = useTranslation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const { detailsName } = useContext(BreadcrumbContext.BreadcrumbProvider.context);

  return (
    <Breadcrumbs aria-label='Breadcrumb' color={'#000000'}>
      {pathnames.length
        ? <Link to={'/'} 
          style={{color: '#000000'}}>
          <HomeIcon fontSize='large' htmlColor='#1622aa'/>
        </Link>
        : <HomeIcon fontSize='large' htmlColor='#1622aa'/>
      }
      {pathnames.map((title: any, index: any) => {
        if (title === 'details') {
          return null;
        }
        else if (title === 'edit') {
          return null;
        }
        else if (title === 'view-interest')
        {return null;
        }
        else if (title === 'view')
        {return null;
        }
        else if (title === 'request-form')
        {return null;
        }
        const isLast = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const x = optionsBreadcrumb.find((x: any) => x.link === to);

        const lastTitle = parseInt(title); // Check if the last in pathname is a number
        if (isLast && !isNaN(lastTitle)) { // Use the id as the last breadcrumb title
          return (
            <Typography color='text.primary' key={title}>
              {t(detailsName)}
            </Typography>
          );
        }
        return isLast
          ? <Typography 
            color='text.primary' key={x?.title} >{t(x?.title || '')}
          </Typography>
          : 
          <Link style={{color: '#000000'}}
            key={x?.title}
            to={to}>
            {t(x?.title || '')}
          </Link>;
      })}
    </Breadcrumbs>
  );
}
export default BreadcrumbPages;